.container {
  position: relative;
  margin-inline-start: -1.2rem;

  &[data-borderless='true'] {
    width: 100%;
    margin-inline-start: 0;
  }
}

.editable {
  cursor: text;
  border-radius: var(--border-radius-medium);
  border: 1px solid transparent;
  height: 3.2rem;
  padding: 0 1.2rem;
  display: flex;
  align-items: center;
  background: transparent;
  color: var(--color-grayscale-ghost);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &:focus-within {
    border-color: var(--color-secondary);
  }

  &:hover {
    background-color: var(--color-grayscale-arsenic);
    color: var(--color-grayscale-white);
    cursor: text;
  }

  &[data-has-error='true'] {
    border-color: var(--color-error);
  }

  &:disabled {
    cursor: default;
    background: transparent;
    color: var(--color-grayscale-ghost);
  }

  &[data-borderless='true'] {
    width: 100%;
    padding: 0.2rem 0;
    height: 2.4rem;
    font-size: 1.4rem;
    font-weight: 400;
    color: var(--color-texts-high-contrast);
    border-radius: 0;

    &:focus-within {
      border-color: transparent;
    }

    &:hover {
      background-color: transparent;
      cursor: text;
    }

    &[data-has-error='true'] {
      border-bottom: 0.1rem solid var(--color-error);
    }
  }
}

.error-tool-tip {
  display: flex;
  position: absolute;
  bottom: -3rem;
  left: 50%;
  transform: translateX(-50%);
  background-color: var(--color-error);
  color: var(--color-texts-high-contrast);
  padding: 0.6rem 0.8rem;
  border-radius: var(--border-radius-small);
  font-size: 1.2rem;
  font-weight: 400;
  transition: all 0.1s ease-in;
  pointer-events: none;
  align-items: center;
  justify-content: center;
  white-space: nowrap;

  &::before {
    content: '';
    position: absolute;
    border: 0.4rem solid transparent;
    border-top-color: var(--color-error);
    bottom: 100%;
    transform: rotate(180deg);
  }
}
